// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gSwM5qYVv7k4gwpzIr6t{flex-direction:column;width:100%;height:100%;display:flex}.gSwM5qYVv7k4gwpzIr6t .WA6fYQnIGY1u_VGFOunV{width:100%;height:-webkit-fit-content;height:fit-content;padding:0 20px 24px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `gSwM5qYVv7k4gwpzIr6t`,
	"tabs": `WA6fYQnIGY1u_VGFOunV`
};
export default ___CSS_LOADER_EXPORT___;
